import { render, staticRenderFns } from "./LancamentosCaixa.vue?vue&type=template&id=5f0852d1&scoped=true"
import script from "./LancamentosCaixa.vue?vue&type=script&lang=js"
export * from "./LancamentosCaixa.vue?vue&type=script&lang=js"
import style0 from "./LancamentosCaixa.vue?vue&type=style&index=0&id=5f0852d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0852d1",
  null
  
)

export default component.exports